import React, { useEffect, useRef, useState } from "react";
import "./AutoScrollableChartStyles.css";

const CHART_CONTAINER_MAX_WIDTH = 20000;
const CHART_LABEL_MIN_WIDTH = 200;

export const AutoScrollableChartContainer = (props) => {
  const { chartRef, data, minHeight = 350, children } = props;

  const [enableScroll, setEnableScroll] = useState(false);
  const [containerWidth, setContainerWidth] = useState(0);
  const scrollAxisRef = useRef(null);
  const chartStateRef = useRef({
    rectangleSet: false,
  });

  useEffect(() => {
    const chartInstance = chartRef.current;
    const sourceCtx = chartRef.current?.ctx;
    const targetCtx = scrollAxisRef.current?.getContext("2d");


    const handleOnComplete = () => {
      if (
        chartStateRef.current &&
        !chartStateRef.current.rectangleSet &&
        chartInstance
      ) {
        const scale = window.devicePixelRatio;
        const yScale = chartInstance.scales["y"];
    
        if (yScale) {
          const copyWidth = yScale.width - 10;
          const copyHeight = yScale.height + yScale.top + 10;
    
          // console.log('copyWidth:', copyWidth);
          // console.log('copyHeight:', copyHeight);
    
          targetCtx.scale(scale, scale);
          targetCtx.canvas.width = copyWidth * scale;
          targetCtx.canvas.height = copyHeight * scale;
          targetCtx.canvas.style.width = copyWidth + "px";
          targetCtx.canvas.style.height = copyHeight + "px";
    
          if (chartRef.current && chartRef.current.canvas instanceof HTMLCanvasElement) {
            // console.log('Drawing image from canvas:', chartRef.current.canvas);
            targetCtx.drawImage(
              chartRef.current.canvas,
              0,
              0,
              copyWidth * scale,
              copyHeight * scale,
              0,
              0,
              copyWidth * scale,
              copyHeight * scale,
            );
            sourceCtx.clearRect(0, 0, copyWidth, copyHeight);
            chartStateRef.current.rectangleSet = true;
          } else {
            console.error('Invalid canvas reference:', chartRef.current?.canvas);
          }
        } else {
          console.error('Invalid y scale:', yScale);
        }
      }
    };

    const handleOnProgress = () => {
      if (
        chartStateRef.current &&
        chartStateRef.current.rectangleSet &&
        chartInstance
      ) {
        var copyWidth = chartInstance.scales["y"].width;
        var copyHeight =
          chartInstance.scales["y"].height + chartInstance.scales["y"].top + 10;
        sourceCtx.clearRect(0, 0, copyWidth, copyHeight);
      }
    };
    const updateChartOptions = () => {
      if (chartInstance) {
        chartInstance.options.animation = {
          onComplete: () => {
            if (enableScroll) {
              handleOnComplete();
            }
          },
          onProgress: () => {
            // console.log(
            //   "enter onProgress",
            //   `[scroll enabled: ${enableScroll}]`,
            // );
            if (enableScroll) {
              handleOnProgress();
            }
          },
        };

        // updateTitlePosition(enableScroll ? "start" : "center");
        chartInstance.update();
        chartInstance.resize();
      }
    };

    const updateTitlePosition = (position) => {
      chartInstance.options.plugins.legend.align = position;
      chartInstance.options.plugins.legend.title.position = position;
      // chartInstance.update();
    };

    updateChartOptions();
  }, [chartRef, enableScroll]);

  useEffect(() => {
    displayContainerWidth();
  }, []);

  

  const setWidthBasedOnData = () => {
    const maxWidth = chartRef.current.canvas.parentElement.parentElement.clientWidth;
    let width = Math.max(chartRef.current.data.labels.length * CHART_LABEL_MIN_WIDTH, maxWidth);

    if (width > CHART_CONTAINER_MAX_WIDTH) {
      width = CHART_CONTAINER_MAX_WIDTH;
    }

    chartRef.current.canvas.parentElement.style.width = width + "px";
    chartRef.current.update();
    chartRef.current.resize();

    displayContainerWidth();
  };

  const displayContainerWidth = () => {
    setContainerWidth(chartRef.current.canvas.parentElement.clientWidth);
  };

  useEffect(() => {

    const needsScroll = () => {
      const canvasParentL1Width =
        chartRef.current.canvas.parentElement.clientWidth;
      const canvasParentL2Width =
        chartRef.current.canvas.parentElement.parentElement.clientWidth;
  
  
      if (canvasParentL1Width > canvasParentL2Width) {
        // console.log("need x scroll");
      } else {
        // console.log("no need x scroll");
      }
  
      return canvasParentL1Width > canvasParentL2Width;
    };
    
    setWidthBasedOnData();
    setEnableScroll(needsScroll());

    if(chartRef){
      chartRef.current.canvas.parentElement.parentElement.scrollLeft = 0;
    }
  }, [data]);

  return (
    <div
      className={`chartWrapper ${enableScroll ? "chartWrapper--scroll" : ""}`} style={{ minHeight }}
    >
      <div className="chartAreaWrapper">
        <div className="chartAreaWrapper__inner">{children}</div>
      </div>
      <canvas
        className="chartWrapper__fixedAxis"
        ref={scrollAxisRef}
        height="300"
        width="0"
      ></canvas>
    </div>
  );
};
